import { Box, MenuItem, Select } from "@mui/material";
import { useState } from "react";
import CustomDateTimePickerUD from "../components/CustomDateTimePickerUD";
import { BacklogTableCellSelect } from "../components/BacklogTableCellSelect";
import { select_options } from "./udCommanColumnProperties";
import axiosInstance from "../../../http-common";

export const render_approval_ud_date_picker = (props) => {
  const { colDef, row } = props;
  const { field } = colDef;
  // const status = row[field];
  return <CustomDateTimePickerUD field={field} row={row} />;
};

export const Render_approval_status_cell = (props) => {
  const { colDef, row } = props;
  const { field } = colDef;
  const [status, set_status] = useState(row[field]);
  // console.log({ rowppoo: row["approval"] });
  if (status === "N") {
    return (
      <Box
        sx={{
          width: "100%",
          height: "100%",
          // padding: "10px",
          // margin: "10px",
          // backgroundColor: status_to_background_color_mapping[row[field]],
          display: "flex",
          justifyContent: "start",
          alignItems: "center",
        }}
      >
        <p className="text-sm p-2">Not Required</p>
      </Box>
    );
  } else {
    return (
      <Box
        sx={{
          width: "100%",
          // height: "100%",
          // padding: "10px",
          // margin: "10px",
          // backgroundColor: status_to_background_color_mapping[row[field]]
        }}
      >
        <Select
          sx={{
            width: "100%",
          }}
          labelId={`${field}-${row.id}-label`}
          id={`${field}-${row.id}`}
          value={row.approval || "Pending"}
          // label="Status"
          // disabled={is_disabled}
          // size='small'
          onChange={(e) => {
            // set_select_status(e.target.value);
            set_status(e.target.value);
            console.log(row, e.target.value);
            // dispatch(handle_backlog_reviewer_remarks_update(backlog, e, excel_row, excel_row.id, key_name));
            const approval_patcher = async (
              batch_no,
              material_type,
              approval
            ) => {
              console.log(batch_no);
              var formdata = new FormData();
              formdata.append("batch_no", batch_no);
              formdata.append("material_type", material_type);
              formdata.append("remark", "Awaiting Approval");
              formdata.append("approval", approval);
              console.log(formdata, "form");
              try {
                const response = await axiosInstance.post(
                  `/v1/qc/update_backlog_status/`,
                  formdata,
                  {
                    headers: {
                      "Content-Type": "multipart/form-data",
                    },
                  }
                );
                console.log(response.data);
              } catch (error) {
                console.error("error", error);
              }
            };
            //   var requestOptions = {
            //     method: "POST",
            //     body: formdata,
            //     redirect: "follow",
            //   };

            //   fetch(
            //     `${backend_url}/v1/qc/update_backlog_status/`,
            //     requestOptions
            //   )
            //     .then((response) => response.json())
            //     .then((result) => {
            //       // dispatch(load_intm_backlog_from_backend());
            //       console.log(result);
            //     })
            //     .catch((error) => console.log("error", error));
            // };
            console.log({ row }, "row data");
            approval_patcher(
              row["batch_number"],
              row["Material Type"],
              e.target.value
            );
          }}
        >
          {select_options.approval_options.map(({ value, label }, index) => (
            <MenuItem
              key={`${row.id}-${value}-${label}-${field}-${index}`}
              value={value}
            >
              {label}
            </MenuItem>
          ))}
        </Select>
        <BacklogTableCellSelect
          excel_row={row}
          key_name={field}
          select_options={[...select_options.approval_options]}
          select_status={row[field] || "Pending"}
        />
      </Box>
    );
  }
};

export const Render_ud_status_cell = (props) => {
  const { colDef, row } = props;
  const { api, id } = props;
  const { field } = colDef;
  const [status, set_status] = useState(row[field]);
  // console.log(row);
  if (status === "N") {
    return (
      <Box
        sx={{
          width: "100%",
          height: "100%",
          // padding: "10px",
          // margin: "10px",
          // backgroundColor: status_to_background_color_mapping[row[field]],
          display: "flex",
          justifyContent: "start",
          alignItems: "center",
        }}
      >
        <p className="text-sm p-2">Not Required</p>
      </Box>
    );
  } else {
    return (
      <Box
        sx={{
          width: "100%",
          // height: "100%",
          // padding: "10px",
          // margin: "10px",
          // backgroundColor: status_to_background_color_mapping[row[field]]
        }}
      >
        <Select
          sx={{
            width: "100%",
          }}
          labelId={`${field}-${row.id}-label`}
          id={`${field}-${row.id}`}
          value={row?.["UD remark"] || "Pending"}
          // label="Status"
          disabled={localStorage.getItem("client_id") === "sunpharma_dewas_sterile_API" ? (row?.["document_received_date"] ? false : true) : false}
          size="small"
          onChange={(e) => {
            // set_select_status(e.target.value);
            set_status(e.target.value);
            // console.log(row, e.target.value);
            // dispatch(handle_backlog_reviewer_remarks_update(backlog, e, excel_row, excel_row.id, key_name));
            const ud_patcher = async (batch_no, material_type, UD_remark) => {
              var formdata = new FormData();
              formdata.append("batch_no", batch_no);
              formdata.append("material_type", material_type);
              formdata.append("remark", "Under UD");
              formdata.append("UD_remark", UD_remark);
              // console.log(formdata);
              try {
                const response = await axiosInstance.post(
                  `/v1/qc/update_backlog_status/`,
                  formdata,
                  {
                    headers: {
                      "Content-Type": "multipart/form-data",
                    },
                  }
                );
                console.log(response.data);
                api.updateRows([{ id, [field]: UD_remark }]);
                // if (UD_remark === "Approved") {
                //   api.updateRows([{ id, _action: "delete" }]);
                // } else {
                //   api.updateRows([{ id, [field]: UD_remark }]);
                // }
              } catch (error) {
                console.error("error", error);
              }
            };
            ud_patcher(
              row["batch_number"],
              row["Material Type"],
              e.target.value
            );
          }}
        >
          {select_options.ud_options.map(({ value, label }, index) => (
            <MenuItem
              key={`${row.id}-${value}-${label}-${field}-${index}`}
              value={value}
            >
              {label}
            </MenuItem>
          ))}
        </Select>
        {/* <BacklogTableCellSelectNew
        excel_row={row}
        key_name={field} select_options={
          [
            ...select_options.approval_options
          ]
        }
        select_status={row[field] || "Pending"}

      /> */}
      </Box>
    );
  }
};
